import { ScrollArea } from "components/ScrollArea/ScrollArea";
import Table from "components/Table";

type TablePlaceholderProps =
  | { columns: number; headers?: string[]; rows: number }
  | { headers: string[]; columns?: number; rows: number };

export const TablePlaceholder = ({
  columns,
  rows,
  headers,
}: TablePlaceholderProps) => {
  // Determine the number of columns to render
  const columnCount = headers ? headers.length : columns!;

  return (
    <ScrollArea orientation="horizontal" className="mb-3">
      <Table>
        <Table.THead>
          {headers
            ? headers.map((header) => (
                <Table.TH key={header}>{header}</Table.TH>
              ))
            : Array.from({ length: columnCount }).map((_, columnIndex) => (
                <Table.TH key={columnIndex}>
                  <div className="h-4 w-full animate-pulse rounded-full bg-bg-subtle" />
                </Table.TH>
              ))}
        </Table.THead>
        <Table.TBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Table.TR key={rowIndex}>
              {Array.from({ length: columnCount }).map((_, columnIndex) => (
                <Table.TD key={columnIndex}>
                  <div className="h-4 w-full animate-pulse rounded-full bg-bg-subtle" />
                </Table.TD>
              ))}
            </Table.TR>
          ))}
        </Table.TBody>
      </Table>
    </ScrollArea>
  );
};
